// extracted by mini-css-extract-plugin
module.exports = {"form":"RegisterForm_form__W7xSZ"};